export const TRANSPORT_RESOURCE_MENUS = {
  rides: 'transport-rides',
  boardings: 'transport-boardings',
  drivers: 'transport-drivers',
  vehicles: 'transport-vehicles',
  patients: 'transport-patients',
  cities: 'transport-cities',
  facilities: 'transport-facilities',
  specialties: 'transport-specialties',
  distances: 'transport-distances',
};

function menuFlags(menu) {
  if (!menu) {
    return {
      canView: false,
      canCreate: false,
      canEdit: false,
      canDelete: false,
    };
  }

  return {
    canView: menu.can_view !== false,
    canCreate: Boolean(menu.can_create),
    canEdit: Boolean(menu.can_edit),
    canDelete: Boolean(menu.can_delete),
  };
}

export function getTransportPermission(user, resource) {
  if (user?.role === 'admin') {
    return { canView: true, canCreate: true, canEdit: true, canDelete: true };
  }

  const menus = user?.allowedMenus || [];
  const specific = menus.find((menu) => menu.name === TRANSPORT_RESOURCE_MENUS[resource]);
  if (specific) return menuFlags(specific);

  const parent = menus.find((menu) => menu.name === 'transport');
  if (parent) return menuFlags(parent);

  const hasAnyTransport = menus.some(
    (menu) => menu.name === 'transport' || String(menu.name || '').startsWith('transport-')
  );

  return {
    canView: hasAnyTransport,
    canCreate: false,
    canEdit: false,
    canDelete: false,
  };
}
